import { render, staticRenderFns } from "./RecipientDetention.vue?vue&type=template&id=fdb022a0&scoped=true&"
import script from "./RecipientDetention.vue?vue&type=script&lang=js&"
export * from "./RecipientDetention.vue?vue&type=script&lang=js&"
import style0 from "./RecipientDetention.vue?vue&type=style&index=0&id=fdb022a0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fdb022a0",
  null
  
)

export default component.exports